<!--  -->
<template>
  <div class="coupon-page">
    <div class="header">
      <div class="ht">
        <img class="span-logo" src="../assets/imgs/LOGO_STEFANO_RICCI.svg" alt />
        <!-- <img class="logo" src="../assets/imgs/sr-logo.png" alt /> -->
      </div>
    </div>

    <div class="list">
      <div class="coupon-box">
        <div class="one-coupon">
          <div class="coupon-top">
            <div class="coupon-left">
              <div class="cl-top">
                <div class="clt-left" @click="showCouponDetail()">
                  <img src="../assets/imgs/sr-logo.png" alt />
                </div>
                <div class="clt-right">
                  <div class="coupon-name ellipsis">{{couponMsg.faceValue}}元</div>
                  <div class="coupon-date">{{couponMsg.startDate}}至{{couponMsg.endDate}}</div>
                  <div class="coupon-surplus" v-if="couponMsg.usageType == 1">
                    满<span class="font-bold">{{couponMsg.money}}</span>元可用
                    <span class="use-type">单次使用</span>
                  </div>
                  <div class="coupon-surplus" v-if="couponMsg.usageType == 2">
                    余额<span class="font-bold">{{couponMsg.leftoverValue}}</span>元
                    <span class="use-type">多次使用</span>
                  </div>
                </div>
              </div>

              <div class="cl-bottom" @click="showCouponDetail()">
                <span>详细信息</span>
                <span class="arrow" v-if="couponMsg.couponShow">︿</span>
                <span class="arrow1" v-else>﹀</span>
              </div>
            </div>
            <div class="coupon-right">
              <img
                class="status-img"
                src="../assets/imgs/jilu.png"
                alt
                @click="showModal('couponModal')"
              />
              <div class="round"></div>
              <div class="round round2"></div>
            </div>
          </div>
          <div class="coupon-detail" v-if="couponMsg.couponShow">
            <p>{{couponMsg.couponName}}</p>
            <p v-if="couponMsg.info != null">使用说明: {{couponMsg.info}}</p>
            <p v-if="couponMsg.useRange == 1">使用门店：仅限大陆所有门店使用</p>
            <p v-if="couponMsg.useRange == 2">
              使用门店：
              <span v-for="(iitem, iindex) in couponMsg.couponShops" :key="iindex">
                {{iitem.shopName}}
                <i v-if="iindex+1 != couponMsg.couponShops.length">,</i>
              </span>
            </p>
            <!-- <p>优惠券编号: {{couponMsg.couponCode}}</p>
            <p v-if="couponMsg.getType == 1 || couponMsg.getType == 2">系统赠送优惠券</p>
            <p v-if="couponMsg.getType == 3">订单消费赠送优惠券</p> -->
            
          </div>
        </div>
      </div>
    </div>

    <div class="form">
      <div class="item" v-if="couponMsg.usageType == 2">
        <input
          class="font-l"
          maxlength="10"
          type="tel"
          onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
          placeholder="请输入核销金额"
          v-model="money"
          ref="input0"
          @focus="inputFocus(0)"
          @blur="inputBlur"
        />
      </div>

      <div class="item query font-l" @click="clerkWrite">立即核销</div>
    </div>

    <div class="modal" v-if="modalName == 'couponModal'">
      <div class="dialog">
        <div class="nav">
          <div
            v-if="false"
            class="one-nav"
            :class="modalNav == 0 ? 'active-nav': ''"
            @click="changeModalNav(0)"
          >
            <div>二维码</div>
          </div>
          <div class="one-nav" :class="modalNav == 1 ? 'active-nav': ''" @click="changeModalNav(1)">
            <div>使用记录</div>
          </div>
        </div>
        <div class="ewm-content" v-if="modalNav == 0">
          <img class="ewm" :src="ewmSrc" alt />
          <div class="time">{{chooseCouponMsg.overTime}} 前有效</div>
        </div>
        <div class="record-content" v-if="modalNav == 1">
          <div v-if="couponMsg.couponRecords.length">
            <div class="one-record" v-for="(item, index) in couponMsg.couponRecords" :key="index">
              <div>使用时间：{{item.useTime}}</div>
              <div>店铺：{{item.shopName}}</div>
              <div>店员用户名：{{item.clerkName}}</div>
            </div>
          </div>

          <div class="empty" v-else>
            <img class="empty-img" src="../assets/imgs/sr-logo-gray.png" alt />
            <div>暂无使用记录</div>
          </div>
        </div>
        <div class="btn-wrapper">
          <button class="btn btn1" @click="hideModal">关闭</button>
          <button class="btn border-left" v-if="modalNav == 0" @click="getEwmSrc">刷新</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../assets/js/api.js";
import util from "../assets/js/util.js";
var that;
export default {
  data() {
    return {
      qrcode: "",
      modalNav: 1,
      modalName: null,
      couponMsg: {},
      money: ""
    };
  },

  components: {},

  computed: {},
  created() {
    that = this;
    that.qrcode = that.$route.params.qrcode;
    that.getData();
  },

  mounted() {},

  methods: {
    getData() {
      that.$http
        .get(api.getMemberConponInfo, {
          params: {
            token: util.getss("token"),
            QRcode: that.qrcode
          }
        })
        .then(res => {
          if (res.code === util.ERR_OK) {
            that.couponMsg = res.data;
            that.couponMsg.couponShow = true;
          } else {
            that.$messagebox.alert(res.msg, "提示").then(action => {
              that.$router.go(-1);
            });
          }
        });
    },
    // 展示优惠券详情
    showCouponDetail() {
      that.couponMsg.couponShow = !that.couponMsg.couponShow;
    },
    // 点击优惠券
    showModal(e) {
      that.modalName = e;
    },
    // 隐藏优惠券弹层
    hideModal() {
      that.modalName = null;
    },
    inputFocus(e) {
      setTimeout(() => {
        that.$refs[`input${e}`].scrollIntoViewIfNeeded();
      }, 400);
    },
    inputBlur() {
      window.scrollTo(0, 0);
    },
    // 核销
    clerkWrite() {
      if (that.couponMsg.usageType == 2) {
        if (that.money == "") {
          that.$toast({ message: "请输入核销金额", duration: 2000 });
          return;
        }
        if (that.money > that.couponMsg.leftoverValue) {
          that.$toast({ message: "核销金额大于余额", duration: 2000 });
          return;
        }
      }

      that.$http
        .post(api.clerkWrite, {
          token: util.getss("token"),
          QRcode: that.qrcode,
          value: that.money
        })
        .then(res => {
          if (res.code === util.ERR_OK) {
            that.$messagebox.alert(res.msg, "提示").then(action => {
              that.$router.go(-1);
            });
          } else {
            // that.$toast({ message: res.msg, duration: 2000 });
            that.$messagebox.alert(res.msg, "提示").then(action => {
              that.$router.go(-1);
            });
          }
        });
    }
  }
};
</script>
<style lang='stylus' scoped>
.coupon-page {
  width: 100vw;
  height: 100vh;
  background: #eee;
  overflow-y: scroll;
  padding-bottom: unit(100px);

  .header {
    width: 100%;
    background: var(--black);
    z-index: 10;

    .ht {
      padding: unit(30px) unit(30px) unit(30px);
      display: flex;
      justify-content: space-between;
      align-items: center;

      .span-logo {
        height: unit(50px);
      }

      .logo {
        height: unit(100px);
      }
    }
  }

  .nav {
    padding: unit(10px) unit(30px);
    display: flex;
    align-items: center;
    background: var(--black);

    .one-nav {
      flex: 1;

      div {
        width: unit(150px);
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: unit(32px);
        color: #ffffff;
        height: unit(70px);
      }
    }

    .active-nav {
      div {
        font-size: unit(36px);
        color: var(--gold);
        border-bottom: unit(8px) solid var(--gold);
      }
    }
  }

  .list {
    // padding: unit(270px) unit(20px) unit(140px);
    padding: unit(40px) unit(20px) unit(40px);

    // 没有优惠券
    .empty {
      width: 100%;
      padding: unit(100px);
      text-align: center;

      .empty-img {
        width: unit(450px);
        margin-bottom: unit(30px);
      }

      div {
        font-size: unit(40px);
        color: #999;
      }
    }

    /* 优惠券盒子 */
    .coupon-box {
      width: 100%;

      .one-coupon {
        width: 100%;
        background: #f6f6f6;
        border-radius: unit(14px);
        margin-bottom: unit(20px);

        .coupon-top {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: stretch;

          .coupon-left {
            flex: 1;
            background: #fff;
            display: flex;
            flex-direction: column;
            border-radius: unit(8px);

            .cl-top {
              padding: unit(10px) 0;
              flex: 1;
              display: flex;
              justify-content: space-between;
              align-items: center;

              .clt-left {
                width: unit(160px);
                height: 100%;
                border-right: 1px dashed #eee;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                  width: unit(120px);
                  height: unit(120px);
                }
              }

              .clt-right {
                flex: 1;
                padding: 0 unit(10px) 0 unit(30px);
                border-radius: unit(10px);

                .coupon-name {
                  width: unit(320px);
                  font-size: unit(38px);
                  font-weight: bold;
                  color: #2a3040;
                  margin-bottom: unit(8px);
                }

                .coupon-date, .coupon-surplus {
                  font-size: unit(22px);
                  color: #787e9a;
                  .font-bold {
                    font-weight: bold;
                    color: #2a3040;
                  }
                }

                .coupon-date {
                  margin-bottom: unit(4px);
                }
              }
            }

            .cl-bottom {
              width: 100%;
              height: unit(45px);
              border-top: 1px solid #eee;
              padding: 0 unit(20px) 0 unit(28px);
              display: flex;
              justify-content: space-between;
              align-items: center;

              span {
                font-size: unit(22px);
                color: #a9a9a9;
              }

              .arrow {
                margin-top: unit(-14px);
              }
            }
          }

          /* 右侧立即使用 */
          .coupon-right {
            width: unit(197px);
            height: unit(203px);
            background: var(--gold);
            position: relative;
            border-radius: unit(8px);

            .use-now {
              border-radius: unit(24px);
              border: unit(2px) solid #fff;
              width: unit(156px);
              height: unit(50px);
              font-size: unit(24px);
              color: #fff;
              span-align: center;
              line-height: unit(50px);
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
            }

            .status-img {
              width: unit(140px);
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
            }

            .round {
              width: unit(26px);
              height: unit(26px);
              background: #eee;
              border-radius: 50%;
              position: absolute;
              left: unit(-13px);
              bottom: unit(-13px);
            }

            .round2 {
              top: unit(-13px);
            }
          }
        }

        /* 下方详情 */
        .coupon-detail {
          padding: unit(22px) unit(22px) unit(12px);
          background: #f6f6f6;
          font-size: unit(22px);
          color: #a9a9a9;
          line-height: unit(32px);
          border-bottom-left-radius: unit(8px);
          border-bottom-right-radius: unit(8px);
          position: relative;
        }
      }

      .canot-use {
        .clt-right {
          div, span {
            color: #a9a9a9 !important;
          }
        }

        .coupon-right {
          background: #ccc !important;
        }
      }
    }
  }

  /* 填写 */
  .form {
    padding: 0 unit(20px);
    margin: 0 auto;

    .item {
      width: 100%;
      height: unit(82px);
      background: rgba(245, 245, 245, 0.15);
      border-radius: unit(40px);
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: unit(40px);

      input {
        flex: 1;
        height: 100%;
        padding: 0 unit(40px) 0;
        color: #666;
        font-size: unit(36px);
        outline: none;
        border: none;
        background: #fff;
      }
    }

    .query {
      display: flex;
      justify-content: center;
      align-items: center;
      background: var(--gold);
      color: #fff;
      border: none;
      border-radius: unit(40px);
      margin-top: unit(60px);
      position: fixed;
      bottom: unit(20px);
      left: unit(20px);
      right: unit(20px);
      width: auto;
      margin: 0;
    }
  }

  .modal {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1000;

    .dialog {
      width: unit(600px);
      height: unit(900px);
      background: #fff;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;

      .nav {
        padding: unit(20px) unit(30px) unit(10px);
        height: unit(100px);
      }

      .ewm-content {
        text-align: center;
        padding: unit(30px);
        height: unit(720px);

        .ewm {
          width: unit(400px);
          height: unit(400px);
          margin: unit(100px) 0 unit(40px);
        }

        .time {
          font-size: unit(30px);
          color: var(--gray);
        }
      }

      .record-content {
        height: unit(720px);
        padding: unit(10px) 0 0;
        overflow-y: scroll;

        .one-record {
          border-bottom: unit(4px) solid #ddd;
          padding: unit(20px) unit(30px) unit(10px);

          div {
            font-size: unit(30px);
            margin-bottom: unit(10px);
          }
        }

        // .one-record:nth-last-of-type(1) {
        // border-bottom: none;
        // }
        .empty {
          width: 100%;
          text-align: center;

          .empty-img {
            width: unit(400px);
            height: unit(400px);
            margin: unit(100px) 0 unit(40px);
          }
        }
      }

      .btn-wrapper {
        width: 100%;
        height: unit(80px);
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: 1px solid var(--gray);

        .btn {
          flex: 1;
          height: 100%;
          background: #fff var(--gray);
          border: none;
          outline: none;
          color: var(--gray);
        }

        .border-left {
          border-left: 1px solid var(--gray);
          color: var(--gold);
        }
      }
    }
  }
}
</style>